import Api from '../common/Api';
import {Backend, headers} from "../common/Config";
import Helpers from '../common/Helpers';

export default class Contratos {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/contrato/create`,
            form: Helpers.processFormData(form),
            headers: {}
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/contrato/update`,
            form: Helpers.processFormData(form),
            headers: {}
        });
        return Helpers.dataReturn(response);
    };

    static async get(page = 0, form) {
        const response = await Api.post({
            url: `${Backend}/contrato/list/${page}`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/contrato/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

}
